var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoGridSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 552,
    height: 582,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#82C5EB",
    d: "m236.319 654.835-31.275-18.013 117.518-126.087h46.439l-132.682 144.1ZM369.001 169.447h-37.909v265.446h37.909V169.447Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82C5EB",
    d: "M217.364 510.735h-37.909v265.447h37.909V510.735ZM444.818 169.447h-37.909v265.446h37.909V169.447Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82C5EB",
    d: "M606.689 207.71v-37.921H435.151v37.921h171.538ZM217.364 434.893h-37.909l75.818-265.446h36.961l-74.87 265.446Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82C5EB",
    d: "M367.185 207.137v-37.921H256.301v37.921h110.884ZM179.455 378.96l10.425-37.921h163.009v37.921H179.455ZM560.442 709.82c-15.164 21.804-36.962 36.025-62.55 36.025-45.491 0-81.505-45.505-81.505-101.439 0-55.933 36.961-101.438 81.505-101.438 33.17 0 58.759 20.856 72.027 54.985 0 0 21.797-14.22 32.222-24.648-18.006-42.662-60.654-68.258-103.302-68.258-67.288 0-121.309 62.569-121.309 140.307 0 77.738 54.021 140.308 121.309 140.308 36.962 0 69.184-18.961 91.93-48.349-16.112-16.117-30.327-27.493-30.327-27.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M558.546 548.656h-37.909v37.921h37.909v-37.921ZM520.637 548.656h-37.909v37.921h37.909v-37.921ZM482.727 548.656h-37.909v37.921h37.909v-37.921ZM444.818 548.656h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 548.656H369v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 548.656h-37.909v37.921h37.909v-37.921ZM331.09 548.656h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 548.656h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 548.656h-37.909v37.921h37.909v-37.921ZM217.364 548.656h-37.909v37.921h37.909v-37.921ZM179.455 548.656h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 548.656h-37.909v37.921h37.909v-37.921ZM103.638 548.656h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 548.656H27.82v37.921h37.91v-37.921ZM558.546 510.735h-37.909v37.921h37.909v-37.921ZM520.637 510.735h-37.909v37.921h37.909v-37.921ZM482.727 510.735h-37.909v37.921h37.909v-37.921ZM444.818 510.735h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 510.735H369v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 510.735h-37.909v37.921h37.909v-37.921ZM331.09 510.735h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 510.735h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 510.735h-37.909v37.921h37.909v-37.921ZM217.364 510.735h-37.909v37.921h37.909v-37.921ZM179.455 510.735h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 510.735h-37.909v37.921h37.909v-37.921ZM103.638 510.735h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 510.735H27.82v37.921h37.91v-37.921ZM558.546 472.814h-37.909v37.921h37.909v-37.921ZM520.637 472.814h-37.909v37.921h37.909v-37.921ZM482.727 472.814h-37.909v37.921h37.909v-37.921ZM444.818 472.814h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 472.814H369v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 472.814h-37.909v37.921h37.909v-37.921ZM331.09 472.814h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 472.814h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 472.814h-37.909v37.921h37.909v-37.921ZM217.364 472.814h-37.909v37.921h37.909v-37.921ZM179.455 472.814h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 472.814h-37.909v37.921h37.909v-37.921ZM103.638 472.814h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 472.814H27.82v37.921h37.91v-37.921ZM558.546 434.893h-37.909v37.921h37.909v-37.921ZM520.637 434.893h-37.909v37.921h37.909v-37.921ZM482.727 434.893h-37.909v37.921h37.909v-37.921ZM444.818 434.893h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 434.893H369v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 434.893h-37.909v37.921h37.909v-37.921ZM331.09 434.893h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 434.893h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 434.893h-37.909v37.921h37.909v-37.921ZM217.364 434.893h-37.909v37.921h37.909v-37.921ZM179.455 434.893h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 434.893h-37.909v37.921h37.909v-37.921ZM103.638 434.893h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 434.893H27.82v37.921h37.91v-37.921ZM558.546 396.972h-37.909v37.921h37.909v-37.921ZM520.637 396.972h-37.909v37.921h37.909v-37.921ZM482.727 396.972h-37.909v37.921h37.909v-37.921ZM444.818 396.972h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 396.972H369v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 396.972h-37.909v37.921h37.909v-37.921ZM331.09 396.972h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 396.972h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 396.972h-37.909v37.921h37.909v-37.921ZM217.364 396.972h-37.909v37.921h37.909v-37.921ZM179.455 396.972h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 396.972h-37.909v37.921h37.909v-37.921ZM103.638 396.972h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 396.972H27.82v37.921h37.91v-37.921ZM558.546 359.051h-37.909v37.921h37.909v-37.921ZM520.637 359.051h-37.909v37.921h37.909v-37.921ZM482.727 359.051h-37.909v37.921h37.909v-37.921ZM444.818 359.051h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 359.051H369v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 359.051h-37.909v37.921h37.909v-37.921ZM331.09 359.051h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 359.051h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 359.051h-37.909v37.921h37.909v-37.921ZM217.364 359.051h-37.909v37.921h37.909v-37.921ZM179.455 359.051h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 359.051h-37.909v37.921h37.909v-37.921ZM103.638 359.051h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 359.051H27.82v37.921h37.91v-37.921ZM558.546 321.13h-37.909v37.921h37.909V321.13ZM520.637 321.13h-37.909v37.921h37.909V321.13ZM482.727 321.13h-37.909v37.921h37.909V321.13ZM444.818 321.13h-37.909v37.921h37.909V321.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 321.13H369v37.921h37.91V321.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 321.13h-37.909v37.921h37.909V321.13ZM331.09 321.13h-37.909v37.921h37.909V321.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 321.13h-37.91v37.921h37.91V321.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 321.13h-37.909v37.921h37.909V321.13ZM217.364 321.13h-37.909v37.921h37.909V321.13ZM179.455 321.13h-37.909v37.921h37.909V321.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 321.13h-37.909v37.921h37.909V321.13ZM103.638 321.13h-37.91v37.921h37.91V321.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 321.13H27.82v37.921h37.91V321.13ZM558.546 283.209h-37.909v37.921h37.909v-37.921ZM520.637 283.209h-37.909v37.921h37.909v-37.921ZM482.727 283.209h-37.909v37.921h37.909v-37.921ZM444.818 283.209h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 283.209H369v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 283.209h-37.909v37.921h37.909v-37.921ZM331.09 283.209h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 283.209h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 283.209h-37.909v37.921h37.909v-37.921ZM217.364 283.209h-37.909v37.921h37.909v-37.921ZM179.455 283.209h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 283.209h-37.909v37.921h37.909v-37.921ZM103.638 283.209h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 283.209H27.82v37.921h37.91v-37.921ZM558.546 245.288h-37.909v37.921h37.909v-37.921ZM520.637 245.288h-37.909v37.921h37.909v-37.921ZM482.727 245.288h-37.909v37.921h37.909v-37.921ZM444.818 245.288h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 245.288H369v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 245.288h-37.909v37.921h37.909v-37.921ZM331.09 245.288h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 245.288h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 245.288h-37.909v37.921h37.909v-37.921ZM217.364 245.288h-37.909v37.921h37.909v-37.921ZM179.455 245.288h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 245.288h-37.909v37.921h37.909v-37.921ZM103.638 245.288h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 245.288H27.82v37.921h37.91v-37.921ZM558.546 207.367h-37.909v37.921h37.909v-37.921ZM520.637 207.367h-37.909v37.921h37.909v-37.921ZM482.727 207.367h-37.909v37.921h37.909v-37.921ZM444.818 207.367h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 207.367H369v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 207.367h-37.909v37.921h37.909v-37.921ZM331.09 207.367h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 207.367h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 207.367h-37.909v37.921h37.909v-37.921ZM217.364 207.367h-37.909v37.921h37.909v-37.921ZM179.455 207.367h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 207.367h-37.909v37.921h37.909v-37.921ZM103.638 207.367h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 207.367H27.82v37.921h37.91v-37.921ZM558.546 169.447h-37.909v37.92h37.909v-37.92ZM520.637 169.447h-37.909v37.92h37.909v-37.92ZM482.727 169.447h-37.909v37.92h37.909v-37.92ZM444.818 169.447h-37.909v37.92h37.909v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 169.447H369v37.92h37.91v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 169.447h-37.909v37.92h37.909v-37.92ZM331.09 169.447h-37.909v37.92h37.909v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 169.447h-37.91v37.92h37.91v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 169.447h-37.909v37.92h37.909v-37.92ZM217.364 169.447h-37.909v37.92h37.909v-37.92ZM179.455 169.447h-37.909v37.92h37.909v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 169.447h-37.909v37.92h37.909v-37.92ZM103.638 169.447h-37.91v37.92h37.91v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 169.447H27.82v37.92h37.91v-37.92ZM558.546 131.526h-37.909v37.921h37.909v-37.921ZM520.637 131.526h-37.909v37.921h37.909v-37.921ZM482.727 131.526h-37.909v37.921h37.909v-37.921ZM444.818 131.526h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 131.526H369v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 131.526h-37.909v37.921h37.909v-37.921ZM331.09 131.526h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 131.526h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 131.526h-37.909v37.921h37.909v-37.921ZM217.364 131.526h-37.909v37.921h37.909v-37.921ZM179.455 131.526h-37.909v37.921h37.909v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 131.526h-37.909v37.921h37.909v-37.921ZM103.638 131.526h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 131.526H27.82v37.921h37.91v-37.921ZM558.546 93.605h-37.909v37.921h37.909V93.605ZM520.637 93.605h-37.909v37.921h37.909V93.605ZM482.727 93.605h-37.909v37.921h37.909V93.605ZM444.818 93.605h-37.909v37.921h37.909V93.605Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 93.605H369v37.921h37.91V93.605Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 93.605h-37.909v37.921h37.909V93.605ZM331.09 93.605h-37.909v37.921h37.909V93.605Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 93.605h-37.91v37.921h37.91V93.605Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 93.605h-37.909v37.921h37.909V93.605ZM217.364 93.605h-37.909v37.921h37.909V93.605ZM179.455 93.605h-37.909v37.921h37.909V93.605Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 93.605h-37.909v37.921h37.909V93.605ZM103.638 93.605h-37.91v37.921h37.91V93.605Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 93.605H27.82v37.921h37.91V93.605ZM558.546-20.158h-37.909v37.92h37.909v-37.92ZM520.637-20.158h-37.909v37.92h37.909v-37.92ZM482.727-20.158h-37.909v37.92h37.909v-37.92ZM444.818-20.158h-37.909v37.92h37.909v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91-20.158H369v37.92h37.91v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001-20.158h-37.909v37.92h37.909v-37.92ZM331.09-20.158h-37.909v37.92h37.909v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183-20.158h-37.91v37.92h37.91v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275-20.158h-37.909v37.92h37.909v-37.92ZM217.364-20.158h-37.909v37.92h37.909v-37.92ZM179.455-20.158h-37.909v37.92h37.909v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547-20.158h-37.909v37.92h37.909v-37.92ZM103.638-20.158h-37.91v37.92h37.91v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728-20.158H27.82v37.92h37.91v-37.92ZM558.546 17.763h-37.909v37.92h37.909v-37.92ZM520.637 17.763h-37.909v37.92h37.909v-37.92ZM482.727 17.763h-37.909v37.92h37.909v-37.92ZM444.818 17.763h-37.909v37.92h37.909v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 17.763H369v37.92h37.91v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 17.763h-37.909v37.92h37.909v-37.92ZM331.09 17.763h-37.909v37.92h37.909v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 17.763h-37.91v37.92h37.91v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 17.763h-37.909v37.92h37.909v-37.92ZM217.364 17.763h-37.909v37.92h37.909v-37.92ZM179.455 17.763h-37.909v37.92h37.909v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 17.763h-37.909v37.92h37.909v-37.92ZM103.638 17.763h-37.91v37.92h37.91v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 17.763H27.82v37.92h37.91v-37.92ZM558.546 55.684h-37.909v37.92h37.909v-37.92ZM520.637 55.684h-37.909v37.92h37.909v-37.92ZM482.727 55.684h-37.909v37.92h37.909v-37.92ZM444.818 55.684h-37.909v37.92h37.909v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M406.91 55.684H369v37.92h37.91v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M369.001 55.684h-37.909v37.92h37.909v-37.92ZM331.09 55.684h-37.909v37.92h37.909v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M293.183 55.684h-37.91v37.92h37.91v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M255.275 55.684h-37.909v37.92h37.909v-37.92ZM217.364 55.684h-37.909v37.92h37.909v-37.92ZM179.455 55.684h-37.909v37.92h37.909v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M141.547 55.684h-37.909v37.92h37.909v-37.92ZM103.638 55.684h-37.91v37.92h37.91v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M65.728 55.684H27.82v37.92h37.91v-37.92ZM27.82 548.656h-37.91v37.921h37.91v-37.921Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#058CD7",
    strokeMiterlimit: 10,
    d: "M27.82 510.735h-37.91v37.921h37.91v-37.921ZM27.82 472.814h-37.91v37.921h37.91v-37.921ZM27.82 434.893h-37.91v37.921h37.91v-37.921ZM27.82 396.972h-37.91v37.921h37.91v-37.921ZM27.82 359.051h-37.91v37.921h37.91v-37.921ZM27.82 321.13h-37.91v37.921h37.91V321.13ZM27.82 283.209h-37.91v37.921h37.91v-37.921ZM27.82 245.288h-37.91v37.921h37.91v-37.921ZM27.82 207.368h-37.91v37.92h37.91v-37.92ZM27.82 169.447h-37.91v37.92h37.91v-37.92ZM27.82 131.526h-37.91v37.921h37.91v-37.921ZM27.82 93.605h-37.91v37.921h37.91V93.605ZM27.82 55.684h-37.91v37.92h37.91v-37.92ZM27.82 17.763h-37.91v37.92h37.91v-37.92ZM27.82-20.158h-37.91v37.92h37.91v-37.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0A2832",
    d: "M58.108 479v-1.79l6.721-7.358a46.478 46.478 0 0 0 1.95-2.247c.51-.643.888-1.246 1.133-1.81.252-.57.378-1.166.378-1.789 0-.716-.173-1.336-.517-1.86a3.359 3.359 0 0 0-1.392-1.213c-.59-.285-1.253-.427-1.989-.427-.782 0-1.465.162-2.048.487A3.356 3.356 0 0 0 61 462.335c-.311.577-.467 1.253-.467 2.029h-2.346c0-1.194.275-2.241.825-3.142a5.725 5.725 0 0 1 2.247-2.108c.955-.504 2.025-.756 3.212-.756 1.193 0 2.25.252 3.172.756a5.677 5.677 0 0 1 2.167 2.038c.524.855.786 1.806.786 2.854 0 .749-.136 1.481-.408 2.197-.265.709-.73 1.502-1.392 2.377-.656.868-1.568 1.929-2.734 3.181l-4.574 4.892v.159h9.465V479H58.108Zm17.311-20.364h2.943l6.92 16.904h.24l6.92-16.904h2.943V479h-2.307v-15.472h-.199L86.516 479h-2.228l-6.363-15.472h-.2V479H75.42v-20.364ZM58.744 310l9.108-18.017v-.159h-10.5v-2.188h13.046v2.307L61.33 310h-2.586Zm15.718-20.364h2.943l6.92 16.904h.24l6.92-16.904h2.943V310H92.12v-15.472h-.199L85.56 310H83.33l-6.363-15.472h-.2V310h-2.306v-20.364ZM261.472 87.278c-1.167 0-2.218-.232-3.152-.696-.935-.464-1.684-1.1-2.248-1.909-.563-.808-.871-1.73-.924-2.764h2.386c.093.921.511 1.684 1.253 2.287.749.597 1.644.895 2.685.895.835 0 1.577-.196 2.227-.587a4.141 4.141 0 0 0 1.541-1.61c.378-.69.567-1.469.567-2.337 0-.888-.196-1.68-.587-2.377a4.303 4.303 0 0 0-1.591-1.66c-.676-.404-1.448-.61-2.317-.617a6.368 6.368 0 0 0-1.919.289c-.656.192-1.196.44-1.62.746l-2.307-.279 1.233-10.023h10.579v2.188h-8.511l-.716 6.005h.119c.418-.33.942-.606 1.571-.825a5.957 5.957 0 0 1 1.969-.328c1.246 0 2.357.298 3.331.895a6.252 6.252 0 0 1 2.307 2.426c.563 1.028.845 2.2.845 3.52 0 1.3-.291 2.46-.875 3.48a6.4 6.4 0 0 1-2.386 2.406c-1.014.584-2.168.875-3.46.875Zm11.029-20.642h2.943l6.921 16.904h.238l6.921-16.904h2.943V87h-2.307V71.528h-.199L283.598 87h-2.228l-6.363-15.472h-.199V87h-2.307V66.636ZM378.466 66.636h2.943l6.921 16.904h.238l6.921-16.904h2.943V87h-2.307V71.528h-.199L389.562 87h-2.227l-6.363-15.472h-.199V87h-2.307V66.636ZM416.466 66.636h2.943l6.921 16.904h.238l6.921-16.904h2.943V87h-2.307V71.528h-.199L427.562 87h-2.227l-6.363-15.472h-.199V87h-2.307V66.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0A2832",
    strokeWidth: 2,
    d: "M104 435h38M104 169h38M369 94v38M407 94v38M445 94v38M180 94v38M104 511h38M107 501l8 8 8-8M123 445l-8-8-8 8M115 508v-70M189 97l-8 8 8 8M359 113l8-8-8-8M182 105h183.5M379 97l-8 8 8 8M397 113l8-8-8-8M372 105h33M417 97l-8 8 8 8M435 113l8-8-8-8M410 105h33M107 425l8 8 8-8M123 179l-8-8-8 8M115 433V172"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h552v582H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGridSize);
export default __webpack_public_path__ + "static/media/logo-grid-size.1e6739e6dd06b7c33fb543e626c9ff72.svg";
export { ForwardRef as ReactComponent };